import { useCallback, useState } from 'react';

// localStorage key for the user's preferred chat LLM provider.
export const CHAT_LLM_PROVIDER_STORAGE_KEY = 'prompta_chat_llm_provider';

// Supported providers sent to BE as `llm_provider` on the chat WS frame.
export const CHAT_LLM_PROVIDERS = {
    ANTHROPIC: 'anthropic',
    OPENAI: 'openai',
};

const VALID_PROVIDERS = Object.values(CHAT_LLM_PROVIDERS);
const DEFAULT_PROVIDER = CHAT_LLM_PROVIDERS.ANTHROPIC;

const readStoredProvider = () => {
    const stored = localStorage.getItem(CHAT_LLM_PROVIDER_STORAGE_KEY);
    return VALID_PROVIDERS.includes(stored) ? stored : DEFAULT_PROVIDER;
};

// Persisted chat LLM provider preference. Defaults to Anthropic (Claude) and
// survives reloads via localStorage. Returns [provider, setProvider].
export const useChatLlmProvider = () => {
    const [provider, setProviderState] = useState(readStoredProvider);

    const setProvider = useCallback((next) => {
        const value = VALID_PROVIDERS.includes(next) ? next : DEFAULT_PROVIDER;
        localStorage.setItem(CHAT_LLM_PROVIDER_STORAGE_KEY, value);
        setProviderState(value);
    }, []);

    return [provider, setProvider];
};

export default useChatLlmProvider;
